module.exports = __webpack_public_path__ + "img/avatar-login.7a1e70b3.png";